import { Box, Button, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Col, Row } from 'reactstrap';
import html2pdf from 'html2pdf.js';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
export default function ViewInvoiceDetails(props) {
  const rowData = props?.rowData;
  const carrierBreakdownKeys =
    rowData?.iaData && Object.keys(JSON.parse(rowData?.iaData));
  // const carrierBreakdownValues = Object.values(JSON.parse(rowData.iaData));
  const iaData = rowData.iaData && JSON.parse(rowData.iaData);
  const extraRows = Object.entries(iaData || {})
    .filter(([key, value]) => key.startsWith('Extra') && value)
    .map(([key, value]) => ({
      label: key,
      value
    }));
  const [valueY, setValueY] = useState(0);
  const [valueX, setValueX] = useState(0);
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const accessorialDescriptions = [
    'Inside Pickup',
    'Inside Delivery',
    'Lift Gate Pickup',
    'Lift Gate Delivery',
    'Residential Pickup',
    'Residential Delivery',
    'Secure Access Pickup',
    'Secure Access Delivery',
    'Limited Access Pickup',
    'Limited Access Delivery',
    'Freeze Protection',
    'Overlength',
    'Hazardous Material',
    'Additional Charges',
    'Declared Value',
    'Call Before Delivery',
    'COD Fee',
    'Miscellaneous Charges'
  ];

  const baseRateDescrptions = [
    'Line Haul',
    'Fuel Surcharge Value',
    // 'Surcharge',
    'Guaranteed Charges'
  ];

  const carrierBreakdownList = [
    'NetCharges',
    'NETCHG',
    'FUEL CHARGES',
    'ACCESSORIAL CHG 01',
    'Net Charge',
    'NET CHARGES',
    'GROSS CHARGES',
    'FUEL SURCHARGE',
    'Net Revenue',
    'Total Accsrl',
    'NETCHARGES',
    'GrossCharge',
    'GROSSCHARGES',
    'Gross Charges',
    'Gross Charge',
    'Base Discount',
    'BaseDiscount',
    'OtherAccessorials',
    'TotalCharge',
    'TotalAccsrl',
    'NetRevenue',
    'FSC',
    'DiscountAmount',
    'DISCOUNT$',
    'CHARGES$',
    'FreightCharges',
    'FUELSURCHARGE',
    'FUELCHARGES',
    'FuelSurcharge',
    'Accessorials',
    'Extra1',
    'Extra2',
    'Extra3',
    'Extra4',
    'Extra5',
    'Extra6',
    'Extra7',
    'Extra8',
    'Extra9',
    'Extra10'
  ];
  function isAlmostEqual(a, b, epsilon = 0.0001) {
    const numA = Number(a);
    const numB = Number(b);
    console.log(a, b, 'check for equal');
    if (isNaN(numA) || isNaN(numB)) return false;

    return Math.abs(numA - numB) < epsilon;
  }
  const applySubChargesSort = (rowA, rowB) => {
    return rowA.order - rowB.order;
  };

  const formatePrice = price => {
    const strPrice = String(price).trim();
    const num = Number(price);

    if (
      strPrice === 'N' ||
      strPrice === 'Y' ||
      strPrice === 'NaN' ||
      isNaN(num)
    ) {
      return '$0.00';
    }

    return num.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const mainCharges = rowData?.surchargesList
    ?.sort(applySubChargesSort)
    .filter(
      s =>
        !accessorialDescriptions.includes(s.description) &&
        s.description !== 'Surcharge'
    );

  const accessorialCharges = rowData?.surchargesList
    ?.sort(applySubChargesSort)
    .filter(s => accessorialDescriptions.includes(s.description));

  const carrierFilteredBreakdown = carrierBreakdownKeys
    .sort(applySubChargesSort)
    .filter(
      item =>
        carrierBreakdownList.includes(item) &&
        ![
          'Net Revenue',
          'netcharges',
          'netcharge',
          // 'net charges',
          'Accessorials',
          'Accessorial',
          'accessorials',
          // 'Total Accsrl',
          'TotalCharge'
        ].includes(item.toLowerCase())
    );

  const netChargeEntry = Object.entries(iaData).find(([key]) =>
    rowData?.carrierName === 'R and L Carriers'
      ? key.replace(/\s+/g, '').toLowerCase() === 'totalcharge'
      : key.replace(/\s+/g, '').toUpperCase() === 'NETCHG' ||
        key.replace(/\s+/g, '').toUpperCase() === 'NETCHARGES' ||
        key.replace(/\s+/g, '').toLowerCase() === 'netrevenue' ||
        key.replace(/\s+/g, '').toLowerCase() === 'netcharge'
  );
  console.log(iaData, rowData, 'netChargeEntry');

  const netChargeObject = netChargeEntry ? netChargeEntry : {};

  const carrierAccessorials = Object.entries(iaData).find(
    ([key]) =>
      key.replace(/\s+/g, '').toLowerCase() === 'accessorials' ||
      key.replace(/\s+/g, '').toUpperCase() === 'ACCESSORIALCHG01' ||
      key.replace(/\s+/g, '').toLowerCase() === 'otheraccessorials' ||
      key.replace(/\s+/g, '').toLowerCase() === 'totalaccsrl'
  );

  const carrierAccessorialsEntry = carrierAccessorials
    ? { [carrierAccessorials[0]]: carrierAccessorials[1] }
    : {};
  const carrierFilteredBreakdownValues = Object.entries(iaData)
    .filter(([key]) => carrierFilteredBreakdown?.includes(key))
    .sort(applySubChargesSort)
    .map(([, value]) => value);
  // const maxLength = Math.max(
  //   mainCharges.length,
  //   carrierFilteredBreakdown.length
  // );
  const maxAccessorials = Math.max(accessorialCharges?.length);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ px: 1, width: '100%' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`
    };
  }

  // HORIZONTAL

  function TabPanelX(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ px: 3, py: 1, maxWidth: '100%' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanelX.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };
  const handleChangeY = (event, newValue) => {
    setValueY(newValue);
    if (newValue === 3) {
    }
  };
  const tableRef = useRef(null);
  const handleGeneratePDF = () => {
    const element = tableRef.current;
    if (element) {
      html2pdf()
        .set({
          margin: 2,
          filename: 'Charges-breakdown.pdf',
          image: { type: 'jpeg', quality: 2 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        })
        .from(element)
        .save();
    }
  };

  const requiredDescriptions = [
    'Base Rate',
    'Discount %',
    'Discount Value',
    'Line Haul',
    'Fuel Surcharge %',
    'Fuel Surcharge Value'
  ];
  return (
    <Box
      sx={{
        // bgcolor: 'background.paper',
        display: 'flex',
        width: '100%',
        borderRadius: '5px',
        // marginTop: -20
        p: 1,
        height: 'auto'
      }}
    >
      <div ref={tableRef}>
        <TableContainer
          elevation={0}
          sx={{
            width: '86vw',
            height: '50vh',
            overflowY: 'auto',
            overflowX: 'hidden',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            boxShadow: 2
          }}
          component={Paper}
        >
          <Table
            sx={{
              width: '86vw',
              '& td, & th': {
                border: '1px solid #e0e0e0'
              }
            }}
          >
            <TableHead>
              <TableRow
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                  backgroundColor: '#f5f5f5',
                  '&:hover': {
                    backgroundColor: '#f7f7f7'
                  }
                }}
              >
                <TableCell sx={{ fontWeight: 'bold' }}>Charge Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>TMS Value</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Charge Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Invoice Value</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Breakdown Status
                  {/* <Tooltip arrow title='Download PDF'>
                    <PictureAsPdfIcon
                      sx={{ cursor: 'pointer', ml: 2 }}
                      // fontSize='30'
                      variant='contained'
                      color='primary'
                      onClick={handleGeneratePDF}
                    />
                  </Tooltip> */}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requiredDescriptions.map((desc, index) => {
                const main = mainCharges?.find(
                  item => item.description.trim() === desc
                ) || {
                  description: desc,
                  amount: { amount: '' }
                };
                let overrideKey = '';
                let overrideValue = '';
                let breakDownMatched = false;

                if (desc === 'Base Rate') {
                  if (
                    main.amount?.amount == iaData.CHARGES$ ||
                    main.amount?.amount == iaData.GROSSCHARGES ||
                    main.amount?.amount == iaData['GROSS CHARGES'] ||
                    main.amount?.amount == iaData['Gross Charges'] ||
                    main.amount?.amount == iaData['Gross Charge'] ||
                    main.amount?.amount == iaData.GrossCharge ||
                    main.amount?.amount == iaData.GrossCharges
                  ) {
                    breakDownMatched = true;
                  }

                  overrideKey = carrierFilteredBreakdown.find(item =>
                    [
                      'CHARGES$',
                      'GROSSCHARGES',
                      'GROSS CHARGES',
                      'Gross Charges',
                      'Gross Charge',
                      'GrossCharge',
                      'GrossCharges'
                    ].includes(item)
                  );

                  overrideValue =
                    iaData.CHARGES$ ||
                    iaData['GROSS CHARGES'] ||
                    iaData['Gross Charge'] ||
                    iaData['Gross Charges'] ||
                    iaData.GROSSCHARGES ||
                    iaData.GrossCharge ||
                    iaData.GrossCharges;
                } else if (desc === 'Discount Value') {
                  if (
                    Math.abs(main.amount?.amount) ==
                      Math.abs(iaData.DiscountAmount) ||
                    Math.abs(main.amount?.amount) ==
                      Math.abs(iaData.DISCOUNT$) ||
                    Math.abs(main.amount?.amount) ==
                      Math.abs(iaData.BaseDiscount) ||
                    Math.abs(main.amount?.amount) ==
                      Math.abs(iaData['Base Discount'])
                  ) {
                    breakDownMatched = true;
                  }

                  overrideKey = carrierFilteredBreakdown.find(item =>
                    [
                      'DiscountAmount',
                      'DISCOUNT$',
                      'BaseDiscount',
                      'Base Discount'
                    ].includes(item)
                  );

                  overrideValue =
                    iaData.DiscountAmount ||
                    iaData.DISCOUNT$ ||
                    iaData.BaseDiscount ||
                    iaData['Base Discount'];
                } else if (desc === 'Fuel Surcharge Value') {
                  if (
                    main.amount?.amount == iaData.FuelSurcharge ||
                    main.amount?.amount == iaData.FUELSURCHARGE ||
                    main.amount?.amount == iaData['FUEL SURCHARGE'] ||
                    main.amount?.amount == iaData['FUEL CHARGES'] ||
                    main.amount?.amount == iaData.FUELCHARGES ||
                    main.amount?.amount == iaData.FSC
                  ) {
                    breakDownMatched = true;
                  }

                  overrideKey = carrierFilteredBreakdown.find(item =>
                    [
                      'FuelSurcharge',
                      'FUELSURCHARGE',
                      'FUEL SURCHARGE',
                      'FUEL CHARGES',
                      'FUELCHARGES',
                      'FSC'
                    ].includes(item)
                  );

                  overrideValue =
                    iaData.FuelSurcharge ||
                    iaData.FUELCHARGES ||
                    iaData.FSC ||
                    iaData['FUEL CHARGES'] ||
                    iaData['FUEL SURCHARGE'] ||
                    iaData.FUELSURCHARGE;
                }

                return (
                  <TableRow
                    sx={{
                      '&:hover': {
                        backgroundColor: '#f7f7f7'
                      }
                    }}
                    key={index}
                  >
                    <TableCell align='left'>
                      {main?.description || ''}
                    </TableCell>

                    <TableCell align='left'>
                      {main?.description?.includes('%')
                        ? main?.amount?.amount
                          ? `${Math.abs(main?.amount?.amount).toFixed(2)}%`
                          : '_'
                        : main?.amount?.amount
                        ? formatePrice(Math.abs(main?.amount?.amount))
                        : '_'}
                    </TableCell>

                    <TableCell
                      align='left'
                      sx={{
                        color:
                          overrideKey &&
                          formatePrice(Math.abs(overrideValue)) !== '_'
                            ? breakDownMatched
                              ? 'green'
                              : 'red'
                            : 'black'
                      }}
                    >
                      {overrideKey || '_'}
                    </TableCell>

                    <TableCell
                      align='left'
                      sx={{
                        color:
                          overrideKey &&
                          formatePrice(Math.abs(overrideValue)) !== '_'
                            ? breakDownMatched
                              ? 'green'
                              : 'red'
                            : 'black'
                      }}
                    >
                      {overrideKey && overrideValue !== ''
                        ? formatePrice(Math.abs(overrideValue))
                        : '_'}
                    </TableCell>

                    <TableCell align='left'>
                      {overrideKey &&
                        formatePrice(Math.abs(overrideValue)) !== '_' && (
                          <Typography
                            sx={{
                              color: breakDownMatched ? 'green' : 'red',
                              // fontWeight: 'bold',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            {breakDownMatched ? '✅ Matched' : '❌ Not Matched'}
                          </Typography>
                        )}
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 1,
                  // backgroundColor: '#f5f5f5',
                  '&:last-child td, &:last-child th': {
                    border: 0
                  },
                  '&:hover': {
                    backgroundColor: '#f7f7f7'
                  }
                }}
              >
                <TableCell sx={{ fontWeight: 'bold' }}>
                  Total Base Charge
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  $
                  {rowData?.surchargesList
                    ?.sort(applySubChargesSort)
                    .filter(
                      s =>
                        baseRateDescrptions.includes(s?.description) &&
                        s.description !== 'Surcharge'
                    )
                    .reduce((total, s) => total + (s?.amount?.amount || 0), 0)
                    .toFixed(2)}
                </TableCell>
                {rowData?.surchargesList?.some(
                  s => !accessorialDescriptions?.includes(s?.description)
                ) ? (
                  <>
                    <TableCell sx={{ fontWeight: 'bold' }}>_</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>_</TableCell>

                    <TableCell sx={{ fontWeight: 'bold' }}>_</TableCell>
                  </>
                ) : (
                  <>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </>
                )}
              </TableRow>

              {(rowData?.surchargesList?.some(s =>
                accessorialDescriptions?.includes(s.description)
              ) ||
                (Object.keys(carrierAccessorialsEntry).length !== 0 &&
                  String(carrierAccessorials[1]).trim() &&
                  !['$-', 'null'].includes(
                    String(carrierAccessorials[1]).trim()
                  ))) && (
                <TableRow
                  sx={{
                    // backgroundColor: '#f5f5f5',
                    '&:last-child td, &:last-child th': {
                      border: 1
                    },
                    '&:hover': {
                      backgroundColor: '#f7f7f7'
                    }
                  }}
                >
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    Accessorials
                  </TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>
                    $
                    {rowData?.surchargesList
                      ?.sort(applySubChargesSort)
                      .filter(s =>
                        accessorialDescriptions.includes(s.description)
                      )
                      .reduce((total, s) => total + (s.amount?.amount || 0), 0)
                      .toFixed(2)}
                  </TableCell>

                  {Object.keys(carrierAccessorialsEntry).length !== 0 &&
                  String(carrierAccessorials[1]).trim() &&
                  !['$-', 'null'].includes(
                    String(carrierAccessorials[1]).trim()
                  ) ? (
                    <>
                      <TableCell sx={{ fontWeight: 'bold' }}>
                        {carrierAccessorials[0]}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>
                        {formatePrice(carrierAccessorials[1])}
                        {/* {String(carrierAccessorials[1]).includes('$')
                          ? carrierAccessorials[1]
                          : `$${Number(carrierAccessorials[1]).toFixed(2)}`} */}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>
                        <Typography
                          sx={{
                            color: isAlmostEqual(
                              rowData?.surchargesList
                                ?.sort(applySubChargesSort)
                                .filter(s =>
                                  accessorialDescriptions.includes(
                                    s.description
                                  )
                                )
                                .reduce(
                                  (total, s) => total + (s.amount?.amount || 0),
                                  0
                                )
                                .toFixed(2),
                              carrierAccessorials[1]
                            )
                              ? 'green'
                              : 'red',
                            // fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.5
                          }}
                        >
                          {isAlmostEqual(
                            rowData?.surchargesList
                              ?.sort(applySubChargesSort)
                              .filter(s =>
                                accessorialDescriptions.includes(s.description)
                              )
                              .reduce(
                                (total, s) => total + (s.amount?.amount || 0),
                                0
                              )
                              .toFixed(2),
                            carrierAccessorials[1]
                          )
                            ? '✅ Matched'
                            : '❌ Not Matched'}
                        </Typography>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                    </>
                  )}
                </TableRow>
              )}
              {extraRows.length > 0 &&
                extraRows.map((extra, index) => (
                  <TableRow
                    key={`extra-${index}`}
                    // sx={{
                    //   backgroundColor: '#fafafa',
                    //   '& td': { border: '1px solid #e0e0e0' }
                    // }}
                  >
                    {/* Charge Type column (Label) */}
                    <TableCell sx={{ fontWeight: 500 }}>_</TableCell>

                    {/* TMS Value (empty) */}
                    <TableCell>_</TableCell>

                    {/* Invoice Charge Type column (Label again or empty) */}
                    <TableCell sx={{ fontWeight: 500 }}>
                      {extra.label}
                    </TableCell>

                    {/* Invoice Value */}
                    <TableCell>{extra.value}</TableCell>

                    {/* Status column (intentionally empty) */}
                    <TableCell>_</TableCell>
                  </TableRow>
                ))}
              {/* {rowData?.surchargesList.some(s =>
              accessorialDescriptions.includes(s.description)
            ) && ( */}
              <TableRow
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 1,
                  backgroundColor: '#f5f5f5',
                  '&:last-child td, &:last-child th': {
                    border: 0
                  },
                  '&:hover': {
                    backgroundColor: '#f7f7f7'
                  }
                }}
              >
                <TableCell sx={{ fontWeight: 'bold', fontSize: 16 }}>
                  Net Charge
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  $
                  {(
                    rowData?.shipmentCharges -
                    (rowData?.surchargesList?.find(
                      item => item.description === 'Surcharge'
                    )?.amount?.amount || 0)
                  ).toFixed(2)}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 16 }}>
                  {rowData?.carrierName === 'R and L Carriers'
                    ? 'TotalCharge'
                    : netChargeObject[0]}
                </TableCell>

                <TableCell sx={{ fontWeight: 'bold' }}>
                  {String(netChargeObject[1]).includes('$')
                    ? netChargeObject[1]
                    : `$${Number(netChargeObject[1]).toFixed(2)}`}
                </TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>
                  {/* Always show Matched or Not Matched */}
                  <Typography
                    sx={{
                      color: isAlmostEqual(
                        rowData?.shipmentCharges -
                          (rowData?.surchargesList?.find(
                            item => item.description === 'Surcharge'
                          )?.amount?.amount || 0),
                        netChargeObject[1]
                      )
                        ? 'green'
                        : 'red',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5
                    }}
                  >
                    {isAlmostEqual(
                      rowData?.shipmentCharges -
                        (rowData?.surchargesList?.find(
                          item => item.description === 'Surcharge'
                        )?.amount?.amount || 0),
                      netChargeObject[1]
                    )
                      ? '✅ Matched'
                      : '❌ Not Matched'}
                  </Typography>

                  {/* Show threshold message only if NOT matched but RESOLVED */}
                  {!isAlmostEqual(
                    rowData?.shipmentCharges -
                      (rowData?.surchargesList?.find(
                        item => item.description === 'Surcharge'
                      )?.amount?.amount || 0),
                    netChargeObject[1]
                  ) &&
                    rowData.iaStatus === 'RESOLVED' && (
                      <Typography
                        sx={{
                          mt: 0.5,
                          color: 'green',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                          fontWeight: 500
                        }}
                      >
                        ✔️ Resolved — Threshold Met
                      </Typography>
                    )}
                </TableCell>
              </TableRow>
              {/* )} */}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Box>
  );
}
